// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1a16ed4e","959":"f1921dd5"}[chunkId] + ".chunk.js";
};